import { useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "../../../components/hooks/useTheme";
import { Tabs } from "../../../components/common/Tabs";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setAppState } from "../../../redux/features/appStateSlice";
import { VehicleReservations } from "./VehicleReservations";
import { ViewVehicle } from "./ViewVehicle";
import { Damages } from "./Damages";
import { BlockedPeriods } from "./blockedPeriods/BlockedPeriods";
import { Expenses } from "./expenses/Expenses";
import GpsTracker from "./gpsTracker/GpsTracker";
import { Relocations } from "./relocations/Relocations";
import { RepairOrder } from "./repairOrder/RepairOrder";
import { VehicleFiles } from "./files/VehicleFiles";
import { VehicleChecklist } from "./checklist/VehicleChecklist";
import { MaintenanceHistory } from "./maintenanceHistory/MaintenanceHistory";


const tabs = [
  { label: "View", hash: "" },
  { label: "Reservations", hash: "reservations" },
  { label: "Damages", hash: "damages" },
  { label: "Blocked Periods", hash: "blocked-periods" },
  { label: "Expenses", hash: "expenses" },
  { label: "Relocations", hash: "relocations" },
  { label: "Repair Orders", hash: "repair-orders" },
  { label: "Maintenance History", hash: "maintenance_histories" },
  { label: "Files", hash: "files" },
  { label: "CheckList", hash: "checklist" },
  { label: "GPS Tracker", hash: "gps-tracker" }
];


const hashToIndex = Object.fromEntries(tabs.map((tab, index) => [`#${tab.hash}`, index]));
const indexToHash = tabs.map(tab => `#${tab.hash}`);

export const EditVehicle = () => {
  const { themeStyles } = useTheme();

  const idNumber = useLocation();
  const navigate = useNavigate();
  const currentHash = idNumber.hash || "";
  const activeIndex = hashToIndex[currentHash] ?? 0;

  const [vehicleDetails, setVehicleDetails] = useState({
    currentLocationId: "",
    odometer: 0,
    fuelLevel: "",
  });
  const [vehicleSelectedClassData, setSelectedVehicleClassData] = useState<any | null>(null);

  const hanbleTabChange = (index: number) => {
    const newHash = indexToHash[index] || "";
    navigate({
      hash: newHash
    }, {
      state: idNumber?.state,
      replace: true
    });
  }

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setAppState("fleet.vehicles"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  return (
    <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
      <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
        <div className="w-full mt-2">
          <Tabs tabs={tabs} onChange={(index,) => hanbleTabChange(index)} activeIndex={activeIndex} />
        </div>

        <div>
          {{
            0: (
              <ViewVehicle
                idNumber={idNumber}
                setSelectedVehicleClassData={setSelectedVehicleClassData}
                setVehicleDetails={setVehicleDetails}
              />
            ),
            1: (
              <VehicleReservations
                idNumber={idNumber}
                vehicleSelectedClassData={vehicleSelectedClassData}
              />
            ),
            2: <Damages idNumber={idNumber} />,
            3: <BlockedPeriods idNumber={idNumber} />,
            4: <Expenses idNumber={idNumber} />,
            5: (
              <Relocations
                idNumber={idNumber}
                vehicleDetails={vehicleDetails}
              />
            ),
            6: <RepairOrder idNumber={idNumber} />,
            7: <MaintenanceHistory idNumber={idNumber} />,
            8: <VehicleFiles idNumber={idNumber} />,
            9: <VehicleChecklist idNumber={idNumber} />,
            10: <GpsTracker idNumber={idNumber} />,
          }[activeIndex] || (
              <ViewVehicle
                idNumber={idNumber}
                setSelectedVehicleClassData={setSelectedVehicleClassData}
                setVehicleDetails={setVehicleDetails}
              />
            )}
        </div>
      </div>
    </div>
  )
}